import { matchPath } from 'react-router-dom';
import storage from '../../presentation/util/storage';

interface UseFolderIdResult {
  folderId: string | null;
  isFromUrl: boolean;
}

/**
 * Get folderId from URL path (non-hook version for use in gateways/non-React code)
 */
export const getFolderIdFromUrl = (): string | null => {
  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

  const match = matchPath<{ dossierId?: string }>(pathname, {
    path: '/dossier/:dossierId',
  });

  return match?.params?.dossierId ?? null;
};

export const useFolderId = (): UseFolderIdResult => {
  // Use window.location directly to avoid Router context dependency in tests
  const urlFolderId = getFolderIdFromUrl();
  const storageFolderId = storage.getFolderId();

  return {
    folderId: urlFolderId || storageFolderId,
    isFromUrl: !!urlFolderId,
  };
};
